<template>
  <div class="text-center">
    <h1>
      Lorem ipsum dolor sit amet
      <br />
      <small>Phasellus varius, ligula nec placerat porta.</small>
    </h1>
    <br />
    <div class="my-2">
      <v-btn rounded color="secondary" dark>Sign In</v-btn>
    </div>
    <div class="my-2">
      <v-btn rounded color="success" dark>Sign Up</v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",

  data: () => ({})
};
</script>
